/**
 * Every path in one place, so a rename is one edit rather than a grep.
 *
 * Short by design. This portal is one page: a dentist arrives on a link, looks
 * at a crown, and decides. There is nowhere else to go and nothing to navigate.
 */
export const ROUTES = {
  home: '/',
  /** What the emailed link points at. The token is the path segment. */
  review: (token: string) => `/r/${token}`,
  reviewPattern: '/r/:token',
  /** The patient's view-only link. */
  patient: (token: string) => `/p/${token}`,
  patientPattern: '/p/:token',
  /** Development only: the review screens against a local case. */
  demo: '/demo',
  demoPatient: '/demo/patient',
} as const;
